import React, { useCallback, useState } from 'react'

type VerificationNumberProps = {
  onUpdatePhoneNumber: (value: string) => void
  defaultPhoneNumber?: string
  isSending?: boolean
}

const VerificationNumber: React.FC<VerificationNumberProps> = ({
  onUpdatePhoneNumber,
  defaultPhoneNumber = '',
  isSending = false,
}) => {
  const [inputValue, setInputValue] = useState(defaultPhoneNumber)

  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value
    const cleaned = raw.replace(/[^\d+]/g, '') // keep digits and +
    setInputValue(cleaned)
  }, [])

  const handleUpdate = useCallback(() => {
    // Trigger the callback with the cleaned input value
    if (inputValue && inputValue.length > 0) {
      onUpdatePhoneNumber(inputValue)
    }
  }, [inputValue, onUpdatePhoneNumber])

  return (
    <div className="flex items-center w-full max-w-sm">
      <input
        id="phone_number"
        type="tel"
        pattern="[0-9+]*"
        value={inputValue}
        onChange={handleChange}
        className="border border-gray-300 rounded-l px-3 py-3 w-full focus:outline-none"
      />
      <button
        type="button"
        onClick={handleUpdate}
        disabled={isSending}
        className="bg-blue-600 text-white px-4 py-3 rounded-r hover:bg-blue-700 disabled:opacity-50"
      >
        {'Update'}
        {isSending && <i className="ms-2 fa fa-spin fa-spinner" />}
      </button>
    </div>
  )
}

export default VerificationNumber
